import React, { Component, Fragment } from 'react';
import {
    Row,
    Card,
    CardBody,
    CardHeader,
    Button,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from 'reactstrap';
import { Colxx } from '../../../components/common/CustomBootstrap';
import { END_POINT } from '../../../constants/defaultValues';
import axios from 'axios';
import IntlMessages from '../../../helpers/IntlMessages';
import {
    NotificatioErrController,
    NotificatioSucController,
} from '../../../helpers/Utils';
import Calendar from '../../../containers/dashboards/Calendar';
import BookingSettingsModal from '../../../containers/dashboards/BookingSettingsModal';
import classnames from 'classnames';import createSocket from "../../../helpers/createSocket";
import { END_POINT_SOCKET } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';

const ROLE_ALIAS = 'booking';

const STATUS_COLORS = {
    pending: 'warning',
    confirmed: 'success',
    cancelled: 'danger',
    completed: 'secondary',
    no_show: 'dark',
};

const STATUS_LABELS = {
    pending: 'Chờ xác nhận',
    confirmed: 'Đã xác nhận',
    cancelled: 'Đã hủy',
    completed: 'Hoàn thành',
    no_show: 'Không đến',
};

const DEFAULT_FORM = {
    customer_name: '',
    customer_phone: '',
    customer_email: '',
    booking_date: '',
    booking_time: '',
    party_size: 2,
    table_id: '',
    special_requests: '',
    notes: '',
    source: 'phone',
};

class BookingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: '1',
            bookings: [],
            todayBookings: [],
            calendarEvents: [],
            tables: [],
            bookedTableIds: [], // Danh sách ID bàn đã đặt theo ngày/giờ được chọn
            settings: null,
            isLoading: false,
            modalAdd: false,
            modalDetail: false,
            modalSettings: false,
            form: { ...DEFAULT_FORM },
            selectedBooking: null,
        };
    }

    componentDidMount() {
        this.loadTodayBookings();
        this.loadTables();
        this.loadSettings();

        // Socket integration
        this.socket = createSocket();
        this.socket.on('connect', () => {
            const user_id = localStorage.getItem('user_id');
            if (user_id) {
                this.socket.emit('join room', { room_id: user_id });
            }
        });

        this.socket.on('new-booking-alert', (data) => {
            NotificationManager.success(
                `Khách hàng ${data.customer_name} vừa đặt bàn!`,
                'Đặt bàn mới',
                5000,
                null,
                null,
                'filled'
            );
            this.loadTodayBookings();
            if (this.state.activeTab === '2') {
                this.loadCalendarEvents();
            }
        });
    }

    componentWillUnmount() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    toggleTab = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
            if (tab === '2') {
                this.loadCalendarEvents();
            }
        }
    };

    toggle = (modal) => {
        this.setState((prev) => {
            const willOpen = !prev[modal];
            let form = { ...DEFAULT_FORM };

            if (modal === 'modalAdd' && willOpen) {
                const nextHour = moment().add(1, 'hours');
                form.booking_date = nextHour.format('YYYY-MM-DD');
                form.booking_time = nextHour.format('HH:mm');
            }

            return {
                [modal]: willOpen,
                form: form,
                selectedBooking: null,
            };
        });
    };

    loadTodayBookings = async () => {
        try {
            this.setState({ isLoading: true });
            const token = localStorage.getItem('access_token');
            const res = await axios.get(`${END_POINT}/booking/today`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            this.setState({ todayBookings: res.data.data || [], isLoading: false });
        } catch (error) {
            console.error('Error loading bookings:', error);
            this.setState({ isLoading: false });
        }
    };

    loadCalendarEvents = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
            const end = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];

            const res = await axios.get(`${END_POINT}/booking/calendar?start=${start}&end=${end}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Convert string dates to Date objects for BigCalendar
            const events = (res.data.data || []).map(evt => ({
                ...evt,
                start: new Date(evt.start),
                end: new Date(evt.end)
            }));

            this.setState({ calendarEvents: events });
        } catch (error) {
            console.error('Error loading calendar events:', error);
        }
    };

    loadTables = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await axios.get(`${END_POINT}/table/all_identify`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // Response is grouped by floor: [{floor: '1', data: [...]}, ...]
            // Flatten to array of tables
            const data = res.data.data || [];
            const tables = data.reduce((acc, group) => {
                if (group.data && Array.isArray(group.data)) {
                    return acc.concat(group.data.map(t => ({ ...t, floor: group.floor })));
                }
                return acc;
            }, []);
            this.setState({ tables });
        } catch (error) {
            console.error('Error loading tables:', error);
        }
    };

    loadSettings = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await axios.get(`${END_POINT}/booking/settings`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            this.setState({ settings: res.data.data });
        } catch (error) {
            console.error('Error loading settings:', error);
        }
    };

    // Lấy danh sách bàn đã đặt theo ngày được chọn
    loadBookedTables = async (date) => {
        if (!date) {
            this.setState({ bookedTableIds: [] });
            return;
        }
        try {
            const token = localStorage.getItem('access_token');
            const res = await axios.get(`${END_POINT}/booking/all?date=${date}&status=pending,confirmed`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const bookings = res.data.data || [];
            // Lấy danh sách table_id đã đặt (loại bỏ null, convert to Number)
            const bookedTableIds = bookings
                .map(b => b.table_id)
                .filter(id => id !== null && id !== undefined)
                .map(id => Number(id));
            console.log('Booked table IDs:', bookedTableIds); // Debug
            this.setState({ bookedTableIds });
        } catch (error) {
            console.error('Error loading booked tables:', error);
        }
    };

    onChangeForm = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            form: { ...prev.form, [name]: value },
        }), () => {
            // Khi user chọn ngày, load danh sách bàn đã đặt
            if (name === 'booking_date') {
                this.loadBookedTables(value);
                // Reset table_id khi đổi ngày
                this.setState((prev) => ({
                    form: { ...prev.form, table_id: '' },
                }));
            }
        });
    };

    onSubmitBooking = async () => {
        const { form } = this.state;

        if (!form.customer_name || !form.customer_phone || !form.booking_date || !form.booking_time) {
            NotificatioErrController('Vui lòng điền đầy đủ thông tin');
            return;
        }

        try {
            const token = localStorage.getItem('access_token');
            await axios.post(`${END_POINT}/booking`, form, {
                headers: { Authorization: `Bearer ${token}` },
            });
            NotificatioSucController('Thêm đặt bàn thành công');
            this.toggle('modalAdd');
            this.loadTodayBookings();
        } catch (error) {
            NotificatioErrController(error.response?.data?.responseText || 'Lỗi khi thêm đặt bàn');
        }
    };

    onUpdateStatus = async (id, status) => {
        try {
            const token = localStorage.getItem('access_token');
            await axios.put(`${END_POINT}/booking/status/${id}`, { status }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            NotificatioSucController('Cập nhật trạng thái thành công');
            this.loadTodayBookings();
            this.toggle('modalDetail');
        } catch (error) {
            NotificatioErrController(error.response?.data?.responseText || 'Lỗi khi cập nhật');
        }
    };

    openBookingDetail = (booking) => {
        this.setState({
            selectedBooking: booking,
            modalDetail: true,
        });
    };

    renderBookingCard = (booking) => {
        return (
            <Card className="mb-3" key={booking.id} onClick={() => this.openBookingDetail(booking)} style={{ cursor: 'pointer' }}>
                <CardBody className="p-3">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h6 className="mb-1 font-weight-bold">{booking.customer_name}</h6>
                            <p className="mb-1 text-muted small">
                                📞 {booking.customer_phone}
                            </p>
                            <p className="mb-0 text-muted small">
                                🕐 {booking.booking_time} | 👥 {booking.party_size} người
                            </p>
                        </div>
                        <Badge color={STATUS_COLORS[booking.status]} className="px-2 py-1">
                            {STATUS_LABELS[booking.status]}
                        </Badge>
                    </div>
                    {booking.table && (
                        <p className="mb-0 mt-2 text-muted small">
                            🪑 Bàn: {booking.table.identify}
                        </p>
                    )}
                </CardBody>
            </Card>
        );
    };

    handleUpdateSettings = async (newSettings) => {
        try {
            const token = localStorage.getItem('access_token');
            const res = await axios.put(`${END_POINT}/booking/settings`, newSettings, {
                headers: { Authorization: `Bearer ${token}` },
            });
            this.setState({ settings: res.data.data, modalSettings: false });
            NotificatioSucController('Cập nhật cài đặt thành công');
        } catch (error) {
            console.error('Update settings error:', error);
            NotificatioErrController('Lỗi khi cập nhật cài đặt');
        }
    };

    render() {
        const {
            activeTab,
            todayBookings,
            modalAdd,
            modalDetail,
            form,
            selectedBooking,
            tables,
            isLoading,
        } = this.state;

        const today = new Date().toISOString().split('T')[0];

        return (
            <Fragment>
                <Row className="mb-3">
                    <Colxx xxs="12">
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className="mb-0">
                                <IntlMessages id="booking.title" />
                            </h1>
                            <div>
                                <Button color="secondary" outline className="mr-2" onClick={() => this.toggle('modalSettings')}>
                                    <i className="simple-icon-settings" />
                                </Button>
                                <Button color="primary" onClick={() => this.toggle('modalAdd')}>
                                    <i className="simple-icon-plus mr-2" />
                                    <IntlMessages id="booking.add-new" />
                                </Button>
                            </div>
                        </div>
                    </Colxx>
                </Row>

                <Row>
                    <Colxx xxs="12">
                        <Card>
                            <CardHeader>
                                <Nav tabs className="card-header-tabs">
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => this.toggleTab('1')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <IntlMessages id="booking.today" />
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => this.toggleTab('2')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <IntlMessages id="booking.calendar" />
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CardHeader>
                            <CardBody>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        {isLoading ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        ) : todayBookings.length > 0 ? (
                                            <div>
                                                {Object.entries(
                                                    todayBookings.reduce((groups, booking) => {
                                                        const hour = parseInt(booking.booking_time.split(':')[0], 10);
                                                        const timeBlock = `${hour}h - ${hour + 1}h`;
                                                        if (!groups[timeBlock]) groups[timeBlock] = [];
                                                        groups[timeBlock].push(booking);
                                                        return groups;
                                                    }, {})
                                                )
                                                .sort((a, b) => parseInt(a[0]) - parseInt(b[0])) // Sort by start hour
                                                .map(([timeBlock, bookings]) => (
                                                    <div key={timeBlock} className="mb-4">
                                                        <div className="mb-3 border-bottom pb-2">
                                                            <i className="simple-icon-clock mr-2 text-primary" />
                                                            {timeBlock} ({bookings.length} khách)
                                                        </div>
                                                        <Row>
                                                            {bookings.map((booking) => (
                                                                <Colxx md="4" key={booking.id}>
                                                                    {this.renderBookingCard(booking)}
                                                                </Colxx>
                                                            ))}
                                                        </Row>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="text-center py-5 text-muted">
                                                <i className="iconsminds-calendar-4 mb-3" style={{ fontSize: '3rem' }} />
                                                <p><IntlMessages id="booking.no-bookings" /></p>
                                            </div>
                                        )}
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Calendar
                                            events={this.state.calendarEvents}
                                            onSelectEvent={(event) => this.openBookingDetail(event.booking)}
                                        />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* Modal Add Booking */}
                <Modal isOpen={modalAdd} toggle={() => this.toggle('modalAdd')} size="lg">
                    <ModalHeader toggle={() => this.toggle('modalAdd')}>
                        <IntlMessages id="booking.add-new" />
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.customer-name" /> *</Label>
                                    <Input
                                        name="customer_name"
                                        value={form.customer_name}
                                        onChange={this.onChangeForm}
                                        placeholder="Tên khách hàng"
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.customer-phone" /> *</Label>
                                    <Input
                                        name="customer_phone"
                                        value={form.customer_phone}
                                        onChange={this.onChangeForm}
                                        placeholder="Số điện thoại"
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.customer-email" /></Label>
                                    <Input
                                        name="customer_email"
                                        type="email"
                                        value={form.customer_email}
                                        onChange={this.onChangeForm}
                                        placeholder="Email (để gửi xác nhận)"
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.party-size" /> *</Label>
                                    <Input
                                        name="party_size"
                                        type="number"
                                        min="1"
                                        value={form.party_size}
                                        onChange={this.onChangeForm}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.date" /> *</Label>
                                    <Input
                                        name="booking_date"
                                        type="date"
                                        min={today}
                                        value={form.booking_date}
                                        onChange={this.onChangeForm}
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.time" /> *</Label>
                                    <Input
                                        name="booking_time"
                                        type="time"
                                        value={form.booking_time}
                                        onChange={this.onChangeForm}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.table" /></Label>
                                    <Input
                                        name="table_id"
                                        type="select"
                                        value={form.table_id}
                                        onChange={this.onChangeForm}
                                    >
                                        <option value="">-- Chọn bàn --</option>
                                        {tables.map((table) => {
                                            // Sử dụng bookedTableIds từ state (được cập nhật khi chọn ngày)
                                            // Nếu chưa có (ngày hôm nay và chưa trigger), fallback từ todayBookings
                                            const today = new Date().toISOString().split('T')[0];
                                            let finalBookedIds = this.state.bookedTableIds;

                                            // Fallback: nếu ngày = hôm nay và bookedTableIds rỗng, lấy từ todayBookings
                                            if (form.booking_date === today && finalBookedIds.length === 0) {
                                                finalBookedIds = todayBookings
                                                    .filter(b => b.table_id && ['pending', 'confirmed'].includes(b.status))
                                                    .map(b => Number(b.table_id));
                                            }

                                            const isBooked = finalBookedIds.includes(Number(table.id));
                                            return (
                                                <option
                                                    key={table.id}
                                                    value={table.id}
                                                    disabled={isBooked}
                                                    style={isBooked ? { color: '#999' } : {}}
                                                >
                                                    Bàn {table.identify} (Khu {table.floor}){isBooked ? ' - Đã đặt' : ''}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>
                            </Colxx>
                            <Colxx md="6">
                                <FormGroup>
                                    <Label><IntlMessages id="booking.source" /></Label>
                                    <Input
                                        name="source"
                                        type="select"
                                        value={form.source}
                                        onChange={this.onChangeForm}
                                    >
                                        <option value="phone">Điện thoại</option>
                                        <option value="walk_in">Trực tiếp</option>
                                        <option value="website">Website</option>
                                        <option value="facebook">Facebook</option>
                                        <option value="zalo">Zalo</option>
                                    </Input>
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <FormGroup>
                            <Label><IntlMessages id="booking.special-requests" /></Label>
                            <Input
                                name="special_requests"
                                type="textarea"
                                rows="2"
                                value={form.special_requests}
                                onChange={this.onChangeForm}
                                placeholder="Yêu cầu đặc biệt của khách..."
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label><IntlMessages id="booking.notes" /></Label>
                            <Input
                                name="notes"
                                type="textarea"
                                rows="2"
                                value={form.notes}
                                onChange={this.onChangeForm}
                                placeholder="Ghi chú nội bộ..."
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.toggle('modalAdd')}>
                            Đóng
                        </Button>
                        <Button color="primary" onClick={this.onSubmitBooking}>
                            Thêm đặt bàn
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Modal Booking Detail */}
                <Modal isOpen={modalDetail} toggle={() => this.toggle('modalDetail')}>
                    <ModalHeader toggle={() => this.toggle('modalDetail')}>
                        Chi tiết đặt bàn
                    </ModalHeader>
                    {selectedBooking && (
                        <>
                            <ModalBody>
                                <div className="mb-3">
                                    <h5 className="font-weight-bold">{selectedBooking.customer_name}</h5>
                                    <Badge color={STATUS_COLORS[selectedBooking.status]} className="mb-2">
                                        {STATUS_LABELS[selectedBooking.status]}
                                    </Badge>
                                </div>
                                <p><strong>📞 Điện thoại:</strong> {selectedBooking.customer_phone}</p>
                                {selectedBooking.customer_email && (
                                    <p><strong>📧 Email:</strong> {selectedBooking.customer_email}</p>
                                )}
                                <p><strong>📅 Ngày:</strong> {selectedBooking.booking_date}</p>
                                <p><strong>🕐 Giờ:</strong> {selectedBooking.booking_time}</p>
                                <p><strong>👥 Số người:</strong> {selectedBooking.party_size}</p>
                                {selectedBooking.table && (
                                    <p><strong>🪑 Bàn:</strong> {selectedBooking.table.identify}</p>
                                )}
                                {selectedBooking.special_requests && (
                                    <p><strong>📝 Yêu cầu:</strong> {selectedBooking.special_requests}</p>
                                )}
                                {selectedBooking.notes && (
                                    <p><strong>📋 Ghi chú:</strong> {selectedBooking.notes}</p>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                {selectedBooking.status === 'pending' && (
                                    <>
                                        <Button color="danger" onClick={() => this.onUpdateStatus(selectedBooking.id, 'cancelled')}>
                                            Hủy
                                        </Button>
                                        <Button color="success" onClick={() => this.onUpdateStatus(selectedBooking.id, 'confirmed')}>
                                            Xác nhận
                                        </Button>
                                    </>
                                )}
                                {selectedBooking.status === 'confirmed' && (
                                    <>
                                        <Button color="warning" onClick={() => this.onUpdateStatus(selectedBooking.id, 'no_show')}>
                                            Không đến
                                        </Button>
                                        <Button color="success" onClick={() => this.onUpdateStatus(selectedBooking.id, 'completed')}>
                                            Hoàn thành
                                        </Button>
                                    </>
                                )}
                            </ModalFooter>
                        </>
                    )}
                </Modal>

                <BookingSettingsModal
                    isOpen={this.state.modalSettings}
                    toggle={() => this.toggle('modalSettings')}
                    setting={this.state.settings}
                    onSave={this.handleUpdateSettings}
                />
            </Fragment>
        );
    }
}

export default BookingPage;
